export const tr = {
    'any-days-selected': {
        one: 'haftada {count} gün',
        some: 'haftada {count} gün\n',
        many: 'haftada {count} gün\n',
        none: 'haftada {count} gün'
    },
    'arbitrary-time': 'Serbest\r',
    daily: 'Her gün',
    'error-min-count-working-days': {
        one: 'Kampanya iş günlerinde en az {count} saat aktif olmalıdır',
        some: 'Kampanya iş günlerinde en az {count} saat aktif olmalıdır',
        many: 'Kampanya iş günlerinde en az {count} saat aktif olmalıdır',
        none: 'Kampanya iş günlerinde en az {count} saat aktif olmalıdır'
    },
    friday: 'Cu',
    hour24: '24 saat',
    monday: 'Pt',
    'not-show': 'Gösterme',
    'range-time': 'Aralık\r',
    saturday: 'Ct',
    show: 'Göster',
    sunday: 'Pa',
    thursday: 'Pe',
    tuesday: 'Sa',
    wednesday: 'Ça',
    weekdays: 'Hafta içi',
    weekends: 'Hafta sonu',
    'work-time': 'Çalışma saatleri'
};
